<template>
<div v-if="finished">
        <Products :answers="answers"/>
    </div>
<div v-else class="base outer-base">
    <div class="lade self-center bg-lightgreen mb-2">
              <div
                class="balken bg-green"
                :style="{ width: `${(currentQuestion / questions.length) * 100}%` }"
              >
              </div>
            </div>
            <div class="question-wrapper">
    <div v-for="(q, i) in questions" :key="q.id" >
          <transition name="fade" mode="out-in">
            <div class="absoulute-fixer" v-if="currentQuestion == i">
              <SurveyQuestion
                v-model="answers[q.id]"
                :question="q"
                :answers="answers"
                :person="person"
                :calorieDeficit="calorieDeficit"
                :calorieDeficitCalculation="calorieDeficitCalculation"
                @next="next"
              />
              <div class="selection_div">
                <button class="text-gray-400" v-if="i > 0" @click="prev">zurück</button>
                
                <button 
                  class="btn ml-8"
                  v-if="q.type != 'multiple' && q.type != 'intro'"
                  :class="{'bg-gray-400 nohover': (q.required && (!answers[q.id]) || answers[q.id] === '') || (q.type == 'multiselect' && q.min && q.min > (answers[q.id] || []).length)}"
                  :disabled="(q.required && (!answers[q.id]) || answers[q.id] === '') || (q.type == 'multiselect' && q.min && q.min > (answers[q.id] || []).length) " 
                  @click="next">
                  weiter
                </button>
                

              </div>
            </div>
          </transition>
    </div>
            </div>
</div>
</template>


<script> 
import SurveyQuestion from "@/components/SurveyQuestion.vue"
import Products from "@/components/Products.vue"
import { Person } from "../util/calorie-calculation/Person"
import { CalorieDeficit } from "../util/calorie-calculation/CalorieDeficit"
import { CalorieDeficitCalculation } from "../util/calorie-calculation/CalorieDeficitCalculation"


export default {
    components: {
        SurveyQuestion, 
        Products
    },
    data () {
        return {
            person: {},
            questions: [
                {
                    type: 'text',
                    question: 'Wie möchtest du gennant werden?',
                    id: 'name',
                    ph: 'Vorname'
                },
                {
                    type: 'email',
                    question: 'Hey {{name}}, um dir deinen persönlichen MyFred zusenden zu können benötigen wir deine E-Mail Adresse:',
                    id: 'email',
                    ph: 'mustermann@gmail.com'
                },
                {
                    type: 'multiple',
                    question: 'Ist Dir Dein täglicher Kalorienbedarf bekannt?',
                    id: 'calorieKnown',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]

                },
                {
                    condition: ['calorieKnown', '==', true],
                    type: 'number',
                    required: true,
                    question: 'Bitte gebe Deinen täglichen Kalorienbedarf ein.',
                    id: 'calorieManual'

                },
                // Start Block 1
                {
                    type: 'multiple',
                    question: 'Welches Geschlecht hast Du?',
                    id: 'gender',
                    width: 110,
                    options: [
                        {
                            value: 'MALE',
                            text: 'Männlich',
                            icon: '/icons/male.png'
                        },
                        {
                            value: 'FEMALE',
                            text: 'Weiblich',
                            icon: '/icons/female.png'
                        }
                    ]
                },
                {
                    type: 'number',
                    required: true,
                    question: 'Wie groß bist Du?',
                    id: 'height',
                    ph: 'z.B. 182',
                    sub: '(In cm)'
                },
                {

                    type: 'number',
                    required: true,
                    question: 'Wie viel wiegst Du?',
                    id: 'weight',
                    ph: 'z.B. 73',
                    sub: '(In kg)'
                },
                {
                    type: 'date',
                    required: true,
                    question: 'Wann bist Du geboren?',
                    id: 'birthday',
                    ph: 'dd.mm.yyyy'
                },
                {
                    condition: ['calorieKnown', '==', false],
                    type: 'number',
                    required: true,
                    question: 'Wie lange schläfst Du täglich im Schnitt?',
                    id: 'sleep',
                    ph: 'z.B. 7',
                    sub: '(In Stunden)'
                },
                {
                    condition: ['calorieKnown', '==', false],
                    type: 'multiple',
                    question: 'Was trifft am ehesten auf Deine Arbeit zu?',
                    id: 'job',
                    height: 230,
                    options: [
                        {
                            value: 'FRAIL_PEOPLE',
                            text: 'Ausschließlich sitzende oder liegende Lebensweise',
                            description: 'z.B. Gebrechliche Menschen',
                            icon: '/icons/watch-tv-in-bed.png'
                        },
                        {
                            value: 'OFFICE_WORKERS',
                            text: 'Überwiegend sitzende Tätigkeit',
                            description: 'z.B. Büroangestellte',
                            icon: '/icons/office-chair-2.png'
                        },
                        {
                            value: 'STUDENTS',
                            text: 'Sitzende, gehende oder stehende Tätigkeit',
                            description: 'z.B. Studenten, Schüler, Laboranten',
                            icon: '/icons/student-female.png'
                        },
                        {
                            value: 'CRAFTSMEN',
                            text: 'Hauptsächlich gehende oder stehende Tätigkeit',
                            description: 'z.B. Handwerker, Kellner, Logistiker',
                            icon: '/icons/walking--v1.png'
                        },
                        {
                            value: 'HEAVY_WORKERS',
                            text: 'Schwere körperliche Arbeit',
                            description: 'z.B. Bauarbeiter, Hochleistungssportler, Waldarbeiter',
                            icon: '/icons/carpenter.png'
                        }
                    ]
                },
                {
                    condition: ['calorieKnown', '==', false],
                    type: 'number',
                    required: true,
                    question: 'Wie lange arbeitest Du pro Tag?',
                    id: 'jobHours',
                    ph: 'z.B. 7,5',
                    sub: 'In Stunden (max. 1 Nachkommastelle)'
                },
                {
                    condition: ['calorieKnown', '==', false],
                    type: 'multiple',
                    question: 'Betreibst Du regelmäßig Sport?',
                    id: 'regularSport',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                // Start Block 2
                {
                    condition: ['regularSport', '==', true],
                    type: 'multiselect',
                    max: 5,
                    min: 1,
                    question: 'Welche Art von Sport wird betrieben?',
                    id: 'sport',
                    sub: '(Maximal 5 Sportarten können eingetragen werden)',
                    options: [
                        {
                            value: 'WALKING',
                            text: 'Laufen',
                            icon: '/icons/sport/running.png'
                        },
                        {
                            value: 'CYCLING',
                            text: 'Radfahren',
                            icon: '/icons/sport/cycling-mountain-bike.png'
                        },
                        {
                            value: 'SWIMMING',
                            text: 'Schwimmen',
                            icon: '/icons/sport/swimming.png'
                        },
                        {
                            value: 'SKIING',
                            text: 'Skilanglauf',
                            icon: '/icons/sport/skiing.png'
                        },
                        {
                            value: 'TENNIS',
                            text: 'Tennis - Einzel',
                            icon: '/icons/sport/tennis.png'
                        },
                        {
                            value: 'TABLETENNIS',
                            text: 'Tischtennis',
                            icon: '/icons/sport/ping-pong.png'
                        },
                        {
                            value: 'WEIGHTLIFTING',
                            text: 'Kraftsport / Bodybuilding',
                            icon: '/icons/sport/dumbbell--v1.png'
                        },
                        {
                            value: 'BADMINTON',
                            text: 'Badminton',
                            icon: '/icons/sport/badminton.png'
                        },
                        {
                            value: 'SOCCER',
                            text: 'Fußball',
                            icon: '/icons/sport/football2--v1.png'
                        },
                        {
                            value: 'VOLLEYBALL',
                            text: 'Volleyball',
                            icon: '/icons/sport/volleyball--v1.png'
                        },
                        {
                            value: 'BASKETBALL',
                            text: 'Basketball',
                            icon: '/icons/sport/basketball--v1.png'
                        },
                        {
                            value: 'HANDBALL',
                            text: 'Handball',
                            icon: '/icons/sport/handball.png'
                        },
                        {
                            value: 'ICEHOCKEY',
                            text: 'Eishockey',
                            icon: '/icons/sport/hockey.png'
                        },
                        {
                            value: 'JUDO',
                            text: 'Judo',
                            icon: '/icons/sport/wrestling.png'
                        },
                        {
                            value: 'GYMNASTICS',
                            text: 'Turnen',
                            icon: '/icons/sport/acrobatics.png'
                        },
                        {
                            value: 'FENCING',
                            text: 'Fechten',
                            icon: '/icons/sport/fencing.png'
                        },
                        {
                            value: 'BOXING',
                            text: 'Boxen',
                            icon: '/icons/sport/boxing.png'
                        },
                        {
                            value: 'EXCERCISE',
                            text: 'Gymnastik',
                            icon: '/icons/sport/gymnastics.png'
                        }
                    ]
                },
                {
                    condition: ['regularSport', '==', true],
                    type: 'sportMultiple',
                    question: 'Mit welcher Intensität wird der Sport betrieben?',
                    id: 'sportIntensity',
                    options: [
                        {
                            value: 0,
                            text: 'Niedrig',
                            description: 'Leichte sportliche Betätigung, ohne Schwitzen oder Kurzatmigkeit'
                        },
                        {
                            value: 1,
                            text: 'Mittel',
                            description: 'Anstrengende, aber nicht überstrapazierende sportliche Betätigung mit etwas Schwitzen und Kurzatmigkeit'
                        },
                        {
                            value: 2,
                            text: 'Hoch',
                            description: 'Massive und sehr anstrengende sportliche Betätigung mit deutlichem Schwitzen und Kurzatmigkeit'
                        }
                    ],
                    icons: {
                        'WALKING': '/icons/sport/running.png',
                        'CYCLING':'/icons/sport/cycling-mountain-bike.png',
                        'SWIMMING': '/icons/sport/swimming.png',
                        'SKIING': '/icons/sport/skiing.png',
                        'TENNIS': '/icons/sport/tennis.png',
                        'TABLETENNIS': '/icons/sport/ping-pong.png',
                        'WEIGHTLIFTING': '/icons/sport/dumbbell--v1.png',
                        'BADMINTON': '/icons/sport/badminton.png',
                        'SOCCER': '/icons/sport/football2--v1.png',
                        'VOLLEYBALL': '/icons/sport/volleyball--v1.png',
                        'BASKETBALL': '/icons/sport/basketball--v1.png',
                        'HANDBALL': '/icons/sport/handball.png',
                        'ICEHOCKEY': '/icons/sport/hockey.png',
                        'JUDO': '/icons/sport/wrestling.png',
                        'GYMNASTICS': '/icons/sport/acrobatics.png',
                        'FENCING': '/icons/sport/fencing.png',
                        'BOXING': '/icons/sport/boxing.png',
                        'EXCERCISE': '/icons/sport/gymnastics.png'
                    }
                },
                {
                    condition: ['regularSport', '==', true],
                    type: 'sportNumber',
                    required: true,
                    question: 'Wie viele Minuten Durchschnittlich pro Woche?',
                    id: 'sportMinutes',
                    ph: 'z.B. 120',
                    sub: '(In Minuten)',
                    icons: {
                        'WALKING': '/icons/sport/running.png',
                        'CYCLING':'/icons/sport/cycling-mountain-bike.png',
                        'SWIMMING': '/icons/sport/swimming.png',
                        'SKIING': '/icons/sport/skiing.png',
                        'TENNIS': '/icons/sport/tennis.png',
                        'TABLETENNIS': '/icons/sport/ping-pong.png',
                        'WEIGHTLIFTING': '/icons/sport/dumbbell--v1.png',
                        'BADMINTON': '/icons/sport/badminton.png',
                        'SOCCER': '/icons/sport/football2--v1.png',
                        'VOLLEYBALL': '/icons/sport/volleyball--v1.png',
                        'BASKETBALL': '/icons/sport/basketball--v1.png',
                        'HANDBALL': '/icons/sport/handball.png',
                        'ICEHOCKEY': '/icons/sport/hockey.png',
                        'JUDO': '/icons/sport/wrestling.png',
                        'GYMNASTICS': '/icons/sport/acrobatics.png',
                        'FENCING': '/icons/sport/fencing.png',
                        'BOXING': '/icons/sport/boxing.png',
                        'EXCERCISE': '/icons/sport/gymnastics.png'
                    }
                },
                // Start Block 3
                {
                    type: 'multiple',
                    question: 'Möchtest Du abnehmen?',
                    id: 'loseWeight',
                    bmi: true,
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                // Start Block 4
                {
                    condition: ['loseWeight', '==', true],
                    type: 'number',
                    question: 'Wie viel Gewicht möchtest Du verlieren?',
                    id: 'weightAmount',
                    ph: 'z.B. 10',
                    sub: '(In kg)'
                },
                {
                    condition: ['loseWeight', '==', true],
                    deficit: true,
                    type: 'number',
                    question: 'In wie vielen Wochen möchtest Du das Gewicht verlieren?',
                    id: 'weeks',
                    ph: 'z.B. 5'
                },
                {
                    condition: ['loseWeight', '==', true],
                    type: 'multiple',
                    question: 'Welche der drei folgenden Aussagen trifft am ehesten auf dich zu?',
                    id: 'question1',
                    height: 130,
                    horizontal: true,
                    options: [
                        {
                            value: 'carbohydrates',
                            text: 'Nach kohlenhydratreichen Mahlzeiten bin ich länger gesättigt als nach eiweißreichen Mahlzeiten.',
                            icon: '/icons/carbohydrates.png'
                        },
                        {
                            value: 'protein',
                            text: 'Nach eiweißhaltigen Mahlzeiten bin ich länger gesättigt als nach kohlenhydratreichen Mahlzeiten.',
                            icon: '/icons/protein.png'
                        },
                        {
                            value: 'neutral',
                            text: 'Ich bin nach eiweiß- und kohlenhydratreichen Mahlzeiten ungefähr gleich lange satt.',
                            icon: '/icons/emoticons/neutral-emoticon--v1.png'
                        }
                    ]
                },
                {
                    condition: ['loseWeight', '==', true],
                    type: 'multiple',
                    question: 'Wie fühlst Du dich nach dem Konsum von zuckerhaltigen Lebensmitteln?',
                    id: 'question2',
                    height: 100,
                    horizontal: true,
                    options: [
                        {
                            value: 'carbohydrates',
                            text: 'Sehr gut, ich fühle mich fit',
                            icon: '/icons/emoticons/happy.png'
                        },
                        {
                            value: 'protein',
                            text: 'Nicht gut, ich fühle mich unruhig und nervös.',
                            icon: '/icons/shaking.png'
                        },
                        {
                            value: 'neutral',
                            text: 'Ich spüre keine Veränderungen.',
                            icon: '/icons/emoticons/neutral-emoticon--v1.png'
                        }
                    ]
                },
                {
                    condition: ['loseWeight', '==', true],
                    type: 'multiple',
                    question: 'Bezogen auf Deine Mahlzeiten: Welche Aussage trifft am ehesten zu?',
                    id: 'question3',
                    height: 130,
                    horizontal: true,
                    options: [
                        {
                            value: 'carbohydrates',
                            text: 'Manchmal vergesse ich zu essen und komme gut ein paar Stunden ohne Essen aus.',
                            icon: '/icons/emoticons/kawaii-pizza.png'
                        },
                        {
                            value: 'protein',
                            text: 'Damit ich mich fit und ausgeglichen fühle, muss ich nach 3-4 Stunden wieder etwas essen.',
                            icon: '/icons/emoticons/fat-emoji.png'
                        },
                        {
                            value: 'neutral',
                            text: 'Am besten geht es mir, wenn ich drei Mahlzeiten am Tag esse.',
                            icon: '/icons/pizza-five-eighths.png'
                        }
                    ]
                },
                {
                    condition: ['loseWeight', '==', true],
                    type: 'multiple',
                    question: 'Bitte vervollständige den Satz: Orangensaft...',
                    id: 'question4',
                    height: 100,
                    horizontal: true,
                    options: [
                        {
                            value: 'carbohydrates',
                            text: '...ersetzt bei mir ab und an eine Mahlzeit und sättigt mich dabei auch.',
                            icon: '/icons/emoticons/happy.png'
                        },
                        {
                            value: 'protein',
                            text: '...löst bei mir Übelkeit und/oder Hungergefühl aus.',
                            icon: '/icons/emoticons/disgusting.png'
                        },
                        {
                            value: 'neutral',
                            text: '...löst bei mir keine der besagten Reaktionen aus.',
                            icon: '/icons/emoticons/neutral-emoticon--v1.png'
                        }
                    ]
                },
                // Start Block 5
                {
                    type: 'multiselect',
                    question: 'Hast Du eine oder mehrere der nachfolgenden Gewohnheiten, die als gesundheitlicher Risikofaktor zu betrachten sind?',
                    id: 'habit',
                    none: true,
                    noneIcon: '/icons/icons8-löschen-50.png',
                    noneText: 'Nein',
                    options: [
                        {
                            value: 'smoking',
                            text: 'Rauchen',
                            icon: '/icons/smoking.png'
                        },
                        {
                            value: 'alcohol',
                            text: 'Alkoholkonsum',
                            icon: '/icons/cocktail.png'
                        }
                    ]
                },
                {
                    type: 'multiple',
                    question: 'Hast Du besondere Ernährungsgewohnheiten?',
                    id: 'eatHabit',
                    options: [
                        {
                            value: 'none',
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        },
                        {
                            value: 'vegan',
                            text: 'Vegan',
                            icon: '/icons/vegetarian-mark.png'
                        },
                        {
                            value: 'vegetarian',
                            text: 'Vegetarisch',
                            icon: '/icons/vegetarian-food.png'
                        },
                        {
                            value: 'flexitarian',
                            text: 'Flexitarisch',
                            icon: '/icons/refreshments.png'
                        }
                    ]
                },
                {
                    type: 'multiselect',
                    question: 'Wurde bei Dir schon einmal der nachfolgende Mangel nachgewiesen?',
                    id: 'deficit',
                    options: [
                        {
                            value: 'vitaminD',
                            text: 'Vitamin D',
                        },
                        {
                            value: 'iron',
                            text: 'Eisen'
                        },
                        {
                            value: 'calcium',
                            text: 'Calcium'
                        },
                        {
                            value: 'zinc',
                            text: 'Zink'
                        },
                        {
                            value: 'vitaminB12',
                            text: 'Vitamin B12'
                        }
                    ]
                },
                {
                    type: 'multiselect',
                    question: 'Aus welchen Gründen möchtest Du Daily Fred konsumieren?',
                    id: 'whyFred',
                    height: 130,
                    options: [
                        {
                            value: 'performanceIncrease',
                            text: 'Kognitive Leistungssteigerung',
                            icon: '/icons/bullish.png'
                        },
                        {
                            value: 'musclegain',
                            text: 'Muskelaufbau',
                            icon: '/icons/flex-biceps.png'
                        },
                        {
                            value: 'weightloss',
                            text: 'Abnehmen',
                            icon: '/icons/squats.png'
                        },
                        {
                            value: 'healthy',
                            text: 'Gesündere Ernährung',
                            icon: '/icons/emoticons/kawaii-broccoli.png'
                        },
                        {
                            value: 'timesafe',
                            text: 'Zeitersparnis',
                            icon: '/icons/clock--v3.png'
                        },
                        {
                            value: 'other',
                            text: 'Sonstiges',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['whyFred', 'includes', 'performanceIncrease'],
                    type: 'multiple',
                    question: 'Bist Du auch an unserem Leistungspaket interessiert?',
                    sub: '(Wir fragen dich, da Du Leistungssteigerung als Grund gewählt hast)',
                    info: 'Ginkgo Biloba, Sibirischer Ginseng',
                    id: 'detox4',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['deficit', 'notIncludes', 'zinc'],
                    type: 'multiple',
                    question: 'Konsumierst Du regelmäßig zinkhaltige Nahrungsergänzungsmittel?',
                    id: 'zink',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['habit', 'includes', 'smoking'],
                    type: 'multiple',
                    question: 'Bist Du auch an unserem DNA-Multiprotect Paket interessiert?',
                    info: 'Astragaluswurzel, Resveratrol, Matcha Grünteeextrakt',
                    id: 'detox2',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['habit', 'includesArray', ['smoking', 'alcohol']],
                    type: 'multiple',
                    question: 'Bist Du auch an unserem Antioxidanzienpaket interessiert?',
                    info: 'Pinienrindenextrakt',
                    id: 'detox3',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    type: 'multiselect',
                    question: 'Konsumierst Du häufig, d.h. mehr als 4x pro Woche..',
                    id: 'consumption',
                    options: [
                        {
                            value: 'sugar',
                            text: 'Zuckerhaltiges',
                            icon: '/icons/sugar-cubes.png'
                        },
                        {
                            value: 'meat',
                            text: 'Fleisch',
                            icon: '/icons/steak-rare.png'
                        },
                        {
                            value: 'whiteFlour',
                            text: 'Weißmehl',
                            icon: '/icons/flour-of-rye.png'
                        },
                        {
                            value: 'coffee',
                            text: 'Kaffee',
                            icon: '/icons/cafe.png'
                        }
                    ]
                },
                {
                    condition: ['consumption', 'includesTwo', true],
                    type: 'multiple',
                    question: 'Bist Du auch an einer Darmreinigung interessiert?',
                    sub: 'Dies ist eine Empfehlung aufgrund Deiner Antworten aus vorheriger Frage.',
                    id: 'colonCleansing',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: [['detox2', 'detox3'], 'arrayIncludes', [false, null]],
                    type: 'multiple',
                    question: 'Bist Du auch an einer Entgiftung von Schwermetallen und Schadstoffen interessiert?',
                    info: 'MSM, Mariendistelextrakt, Bentonit',
                    id: 'detox1',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                // Start Block 6
                /*
                {
                    type: 'slider',
                    question: 'Wie wichtig ist Dir, dass ein ProDukt aussschließlich aus natürlichen Zutaten besteht?',
                    id: 'natural',
                    sub: '(Also auch keine natürlichen Aromen)',
                    options: [
                        {
                            value: 0,
                            text: 'Unwichtig',
                            icon: 'https://img.icons8.com/ios/50/000000/thumbs-down.png'
                        },
                        {
                            value: 1,
                            text: 'Neutral'
                        },
                        {
                            value: 2,
                            text: 'Wichtig',
                            icon: 'https://img.icons8.com/ios/50/000000/thumb-up.png'
                        }
                    ]
                },
                {
                    type: 'slider',
                    question: 'Wie wichtig ist Dir der Geschmack eines Lebensmittels?',
                    id: 'taste',
                    options: [
                        {
                            value: 0,
                            text: 'Unwichtig',
                            icon: 'https://img.icons8.com/ios/50/000000/thumbs-down.png'
                        },
                        {
                            value: 1,
                            text: 'Neutral'
                        },
                        {
                            value: 2,
                            text: 'Wichtig',
                            icon: 'https://img.icons8.com/ios/50/000000/thumb-up.png'
                        }
                    ]
                },*/
                // Start Block 7
                {
                    type: 'multiple',
                    question: 'Isst Du regelmäßig Paranusskerne?',
                    id: 'nuts',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['nuts', '==', true],
                    type: 'number',
                    question: 'Wie viele Paranusskerne isst Du grob pro Woche?',
                    id: 'nutsamount',
                    ph: 'z.B. 5'
                },
                {
                    condition: ['eatHabit', '==', 'none'],
                    type: 'multiple',
                    question: 'Isst Du regelmäßig Fisch?',
                    id: 'fish',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['fish', '==', true],
                    type: 'number',
                    question: 'Wie oft isst Du Fisch pro Woche?',
                    id: 'fishamount',
                    ph: 'z.B. 5'
                },
                {
                    condition: ['eatHabit', '!=', 'vegan'],  // oder none oder flexitarian
                    type: 'multiple',
                    question: 'Konsumierst Du regelmäßig Milchprodukte?',
                    id: 'milk',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        }
                    ]
                },
                {
                    condition: ['milk', '==', true],
                    type: 'number',
                    question: 'An wie vielen Tagen in der Woche konsumierst Du Milchprodukte?',
                    id: 'milkamount',
                    ph: 'z.B. 5'
                },
                {
                    type: 'multiple',
                    question: 'Nutzt Du regelmäßig jodiertes Speisesalz?',
                    id: 'salt',
                    options: [
                        {
                            value: true,
                            text: 'Ja',
                            icon: '/icons/checkmark--v1.png'
                        },
                        {
                            value: false,
                            text: 'Nein',
                            icon: '/icons/icons8-löschen-50.png'
                        },
                        {
                            value: null,
                            text: 'Weiß ich nicht',
                            icon: '/icons/question-mark--v1.png'
                        }
                    ]
                }
            ],
            answers: {},
            currentQuestion: 0,
            finished: false,
            calorieDeficit: {},
            calorieDeficitCalculation: {}

        }
    },
    watch: {
        currentQuestion() {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push ({
                    "event": 'survey-question-'+this.questions[this.currentQuestion].id,
                    "humanReadbleQuestion": this.questions[this.currentQuestion].question,
            })
        },
        answers: {
            deep: true,
            handler () {
                if (this.answers['gender'] != null && this.answers['birthday'] != null && this.answers['weight'] != null && this.answers['height'] != null) {
                    this.person = new Person (this.answers['gender'], this.answers['birthday'], this.answers['weight'], this.answers['height'])
                    console.log(this.person)
                }
                if (this.answers['weightAmount'] != null) {
                    this.calorieDeficit = new CalorieDeficit (parseInt(this.answers['weightAmount']))
                }
                if (this.answers['weeks'] != null) {
                    this.calorieDeficitCalculation = new CalorieDeficitCalculation (parseInt(this.answers['weightAmount']), parseInt(this.answers['weeks']))
                }

            }
        },
        shakeInRoute: {
            deep: true,
            immediate: true,
            handler () {
                if (this.shakeInRoute) {
                    this.finished = true
                }
            }
        }
  },
  computed: {
      shakeInRoute () {
          const search = new URLSearchParams(window.location.search)
          return search.get('shake')
      }
  },
  created() {
    this.questions.forEach((q) => {
      this.$set(this.answers, q.id, null);
    });
    if(this.$route.name == 'Products'){
      this.finished = true
    }
  },
  methods: {
    evalCondition(condition) {
      if (condition && Array.isArray(condition) && condition.length == 3) {
        let [key, operator, val] = condition;
        switch (operator) {
          case "==":
            return this.answers[key] == val;
          case "!=":
              return this.answers[key] != val;
          case ">":
            return this.answers[key] > val;
          case "<":
            return this.answers[key] < val;
          case ">=":
            return this.answers[key] >= val;
          case "<=":
            return this.answers[key] <= val;
          case "includes":
            return (
              Array.isArray(this.answers[key]) &&
              this.answers[key].includes(val)
            );
          case "notIncludes":
            return Array.isArray(this.answers[key]) && !this.answers[key].includes(val)
          case "includesTwo":
              return Array.isArray(this.answers[key]) && this.answers[key].length >= 2
          case "arrayIncludes":
              return Array.isArray(key) && !(key.map(k => this.answers[k]).map(a => val.includes(a)).includes(false))
          case "includesArray":
              return Array.isArray(val) && this.answers[key].map(a => val.includes(a)).includes(true);
          case "includedIn":
            return Array.isArray(val) && val.includes(this.answers[key]);
          default:
            return true;
        }
      } else {
        return true;
      }
    },
    prev() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        if (
          this.evalCondition(this.questions[this.currentQuestion].condition) !=
          true
        ) {
          this.prev();
        }
      }
    },
    next() {
      if(this.evalCondition(this.questions[this.currentQuestion].condition) == true){
      try{
          window.dataLayer = window.dataLayer || []
          let anwers = [this.answers[this.questions[this.currentQuestion].id]].flat()
          console.log({anwers})
          let anwersObj = anwers.reDuce((acc,elm,idx)=>({...acc, [`anwers0${idx+1}`]: elm}), {})
          window.dataLayer.push ({
                "event": 'survey-question-'+this.questions[this.currentQuestion].id+'-answered',
                "humanReadbleQuestion": this.questions[this.currentQuestion].question,
                ...anwersObj
          })
        }catch(err){
          console.warn(err)
        }
      try{
          let currentQuestionObj = this.questions[this.currentQuestion]
          window._learnq = window._learnq || [];

          if(currentQuestionObj.id === "email" && this.answers[currentQuestionObj.id]){
          window._learnq.push(['identify', {
            '$email' : this.answers[currentQuestionObj.id]
          }])}else if(currentQuestionObj.id === "name" && this.answers[currentQuestionObj.id]){
          window._learnq.push(['identify', {
            '$first_name' : this.answers[currentQuestionObj.id]
          }])}else if(currentQuestionObj.id === "age" && this.answers[currentQuestionObj.id]){
          window._learnq.push(['identify', {
            'Birth Year' : new Date().getFullYear() - this.answers[currentQuestionObj.id]
          }])}else if(this.answers[currentQuestionObj.id]){
            window._learnq.push(['identify', {
            [`survey-question-${currentQuestionObj.id}`] : this.answers[currentQuestionObj.id],
            a: 2
          }
          ])}

          
        }catch(err){
          console.warn(err)
        }
      }
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
        if (
          this.evalCondition(this.questions[this.currentQuestion].condition) !=
          true
        ) {
          this.next();
        }
      } else {
        this.finished = true;
        window.dataLayer = window.dataLayer || []
          window.dataLayer.push ({
                "event": 'youguide-survey-completed'
          })
      }
    },
  },
}

</script>


<style>

.outer-base {
    min-height: 600px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
}

.question-wrapper {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-active {
  transition-delay: 0s;
  display: none;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(10px);
}
.nex{
    background-color: #63AE89
}
.nex:hover{
    background-color: #85C7A8
}
.lade {
  font-weight: 400;
  overflow: hidden;
  height: 12px;
  width: 100%;
  border-radius: 5px;
  outline: 0px;
  margin: auto;
  margin-top: 20px;
}

@media (min-width: 640px){
    .lade {
        width: 50%
    }
}
@media (max-width: 640px){
    .lade {
        width: 70%
    }
}

.balken {
  font-weight: 400;
  background-color: #002c4d;
  height: 12px;
  outline: 0px;
  transition: width 1s;
}
.bg-green{
  background-color: #63AE89
}
.bg-lightgreen{
  background-color: #85C7A8
}
.nicebutton{
    background: #63ae89 0 0 no-repeat padding-box;
    border-radius: 99px!important;
    padding: 14px 40px!important;
    font-family: 'Work Sans',sans-serif!important;
    text-transform: none!important;
    letter-spacing: .03em!important;
    font-weight: 500!important;
    font-size: 16px!important;
    margin-top: 23px!important;
    margin-bottom: 30px;
    color: white
}

.nicebutton:hover{
    background: #85bfa2;
}
.nohover{
    pointer-events: none;
}
.base{
    text-align: center;
    margin-bottom: 2rem
}
.section-header__title{
    font-size: calc(var(--typeHeaderSize)*.85)!important;
}

</style>